import React, {FC} from 'react';
import styled from 'styled-components';
import Icon, {IconSize} from '../../Icon/Icon';
import {GenericIconName} from '../../Icon/IconName';
import ClientSideLink from '../../Navigation/ClientSideLink/ClientSideLink';
import {primaryColor} from '../../constants/colors';
import {fsS, fwMediumBold} from '../../constants/typography';

const QuestionLinkWrapper = styled(ClientSideLink)`
  display: flex;
  text-decoration: none;
  padding-bottom: 20px;
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${primaryColor};
  }
`;
const QuestionLinkIcon = styled(Icon)`
  margin-right: 6px;
  margin-top: 1px;
`;
const QuestionLinkText = styled.div`
  font-size: ${fsS}px;
  ${fwMediumBold};
  line-height: 1.25;
  letter-spacing: normal;
  color: ${primaryColor};
`;

const HelpSectionTileQuestionLink: FC<{label: string; url: string}> = ({
  label,
  url,
}) => (
  <QuestionLinkWrapper href={url}>
    <QuestionLinkIcon
      data-testid="HelpCenterQuestionIcon"
      size={IconSize.XS}
      asset={GenericIconName.IcQuestionFillAlt}
    />
    <QuestionLinkText data-testid="FaqSectionPromotedArticle">
      {label}
    </QuestionLinkText>
  </QuestionLinkWrapper>
);

export default HelpSectionTileQuestionLink;
